import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ToastrService } from 'ngx-toastr'; 
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
import { SeedReservationReconciliationService } from '../../../../services/seed/seed-reservation-reconciliation.service';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-seed-reservation-reconcile-add-product',
  templateUrl: './seed-reservation-reconcile-add-product.component.html',
  styleUrls: ['./seed-reservation-reconcile-add-product.component.scss']
})
export class SeedReservationReconcileAddProductComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  public productList: any;
  public selectedProductList = new Array();
  productDataSource: MatTableDataSource<any>;
  growerList: any;
  selectedValue: string;
  searchTypeList: string[] = ['Product Name', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Item Number', 'Maturity'];
  displayedColumns: string[] = ['SeedAvailability', 'NetBEU', 'DealerBucket', 'Product Name', 'Pack Size', 'Seed Size', 'Technology', 'Treatment', 'Maturity', 'Units', 'Delivery Date', 'Product Line'];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  filterValueList = new Array();
  isTextBoxEmpty = false;
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  itemNumberList: any = [];
  productFilters: any;
  selectedData: any;
  reservationUnits = 0;
  pendingReservationUnits = 0;
  unitSelected = 0;

  isFromGoBack = false;
  dateFilter: any;
  datemodel: NgbDateStruct;
  activeCropYear: any;
 
  constructor(
    public seedReservationReconciliationService: SeedReservationReconciliationService,
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private sliderModelService: SliderModelService,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private router: Router,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar
  ) {
    this.sliderModelService.seedReservationReconcileSliderValue.subscribe(x => {
      this.selectedData = x;
      this.headerYear = +x.cropYear;
      this.reservationUnits = +x.reservationUnits;
      this.pendingReservationUnits = +x.pendingReservationUnits;
      this.isFromGoBack = !!(x && x.isFromGoBack);
    });
  }

  ngOnInit() {
    this.selectedValue = this.searchTypeList[0];
    if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
      this.activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    }
    this.resetProductFilter();
    this.bindDataSource([]);
    this.getIntialLoadData();
    this.loadMasterData();
    this.validateDateFilter();
    this.validateDeliveryDateFilter();
  }


  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);

      const calendarDate = d;
      let maxDate = new Date();
      if (this.activeCropYear) {
        maxDate = new Date(this.activeCropYear.endDate);
      }
      return calendarDate >= currentDate && calendarDate <= maxDate;
    };
  }


  onGrowerChange(grower: any) {
    if (grower) {
      this.selectedData.growerOrderId = grower.growerOrderId;
      this.selectedData.growerOrderNumber = grower.growerOrderNumber;
    } else {
      this.selectedData.growerOrderId = null;
      this.selectedData.growerOrderNumber = null;
    }
  }

  validateDeliveryDateFilter() {
    const currentDate = new Date();
    let maxDate = new Date();
    if (this.activeCropYear) {
      maxDate = new Date(this.activeCropYear.endDate);
    }
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.datemodel = this.configDate.getToday();
    this.config.maxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
  }

  syncSelectedItem(element: any) {
    const selected = this.selectedProductList.find(i => i.itemNumber === element.itemNumber);
    if (selected) {
      selected.desiredDeliveryDate = element.desiredDeliveryDate;
    }
    if (!element.isProductSelected && element.reservationUnits > 0) {
      this.keepRecords(element);
    }
  }



  geuTextChange(element: any) {
    if (
      element.reservationUnits === null ||
      element.reservationUnits === undefined ||
      (typeof element.reservationUnits === 'string' && element.reservationUnits.trim() === '') ||
      isNaN(Number(element.reservationUnits))
    ) {
      element.reservationUnits = 0;
    }

    this.updateRowData(element);
  }

  geuValueChange(action: string, productItem: any) {
    if (action == 'decrease') {
      const decValue = +productItem.reservationUnits - +productItem.conv;
      if (decValue > 0) {
        const valueBeforeDec = productItem.reservationUnits;
        productItem.reservationUnits = Math.floor(productItem.reservationUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.reservationUnits) {
          productItem.reservationUnits = (+productItem.reservationUnits > +productItem.conv ? +productItem.reservationUnits - +productItem.conv : 0);
        }
      }
      else {
        productItem.reservationUnits = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.reservationUnits;
      productItem.reservationUnits = Math.ceil(productItem.reservationUnits / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.reservationUnits) {
        productItem.reservationUnits = (+productItem.reservationUnits + +productItem.conv);
      }
    }

    this.updateRowData(productItem);
  }

  updateRowData(element:any) {
    if ((element.reservationUnits <= 0 && element.isProductSelected) ||
      (element.reservationUnits > 0 && !element.isProductSelected)) {
      this.keepRecords(element);
    } else {
      const selected = this.selectedProductList.find(i => i.itemNumber === element.itemNumber);
      if (selected) {
        selected.reservationUnits = +element.reservationUnits;
      }
    }

    this.calculateTotalUnitsSelected();
  }


  calculateTotalUnitsSelected() {
    const total = this.productList?.reduce((sum, item) => sum + (+item.reservationUnits || 0), 0);
    this.unitSelected = Math.round(total * 1000) / 1000;
  }



  get remainingReservationUnit(): number {
    const val = Math.max((+this.pendingReservationUnits || 0) - (+this.unitSelected || 0), 0);
    return Math.round(val * 1000) / 1000;
  }

  getIntialLoadData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReservationReconciliationService.getProductIntialSetup(
       +this.selectedData.accountNo,
       +this.selectedData.gmk,
       this.selectedData.isParentGMK
    ).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.growerList = result
        this.growerList.forEach(grower => {
          grower.businessName = (grower.businessName == null || grower.businessName == '' ?
            (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
            (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
            (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
            : grower.businessName);
        });

        const grower = this.growerList.find(g => g.gmk === this.selectedData.gmk) ?? this.growerList[0];
        this.selectedData.growerOrderId = grower.growerOrderId;
        this.selectedData.growerOrderNumber = grower.growerOrderNumber;
      }
      this.loaderService.setLoaderStatus(false);
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      })));
    
  }

    growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1);
  }


  public bindDataSource(data: any[]) {
    this.productDataSource = new MatTableDataSource(data);
  }

  getProducts() {
    const growerGMK = +(this.selectedData?.gmk ?? this.selectedData?.growerGMK ?? 0);
    this.productFilters.ScreenName = 'grower';
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = +this.selectedData.accountNo;
    this.productFilters.GrowerGMK = growerGMK > 0 ? growerGMK : null;
    if (!this.validateProductFilter(this.productFilters)) {
      this.toastrService.error('Value must greater than equal to 2 characters.');
      return true;
    }
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReservationReconciliationService.getReconciliationProductAvailability(this.productFilters).subscribe((result: any) => {
      let newProducts = [];

      if (result && result.status) {
        newProducts = result.resultData;
        newProducts.forEach(product => {
          product.ProductName = (product.brand != null ? product.brand : '') + (product.marketingBrand != null ? (' - ' + product.marketingBrand) : '');
          product.productNameFilter = (product.brand != null ? product.brand : '');
          // Check if already selected - preserve values
          const existing = this.selectedProductList.find(i => i.itemNumber === product.itemNumber);
          if (existing) {
            product.isProductSelected = true;
            product.reservationUnits = existing.reservationUnits;
            product.desiredDeliveryDate = existing.desiredDeliveryDate;
            product.isFromPreviousSearch = false;
          } else {
            product.isProductSelected = false;
            product.reservationUnits = 0;
            product.desiredDeliveryDate = null;
            product.isFromPreviousSearch = false;
          }
        });
      } else {
        if (result) {
          this.toastrService.info(result.message);
        } else {
          this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
        }
      }

      const selectedNotInResults = this.selectedProductList.filter(
        sel => !newProducts.find((p: any) => p.itemNumber === sel.itemNumber)
      ).map(sel => ({ ...sel, isFromPreviousSearch: true }));

      this.productList = [...selectedNotInResults, ...newProducts];

      // Reposition based on selectedProductList order
      this.repositionAllSelectedRows();

      this.bindDataSource(this.productList);
      this.loaderService.setLoaderStatus(false);
      this.calculateTotalUnitsSelected();
    }, (error) => {
      // On error, still show selected items
      this.productList = this.selectedProductList.map(item => ({ ...item, isFromPreviousSearch: true }));
      this.bindDataSource(this.productList);
      this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
      this.calculateTotalUnitsSelected();
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    }));
  }

  repositionAllSelectedRows() {
    if (!this.productList || this.productList.length === 0) return;

    const selectedInOrder = this.selectedProductList
      .map(sel => this.productList.find(p => p.itemNumber === sel.itemNumber))
      .filter(p => p);

    const unselected = this.productList.filter(p => !p.isProductSelected);

    this.productList = [...selectedInOrder, ...unselected];
  }


  public getProductFilters(productFilter) {
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = +this.selectedData.accountNo;
    return productFilter;
  }

  // to validate product filter
  public validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.TechnologyList != null && productFilter.TechnologyList !== '' && productFilter.TechnologyList.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Item Number
    if (productFilter.ItemNoList != null && productFilter.ItemNoList.length > 0) {
      isValid = true;
    }

    // To Validate Maturity Min & Max
    if (productFilter.MaturityMin != null && productFilter.MaturityMax != null) {
      isValid = true;
    }
    if (this.selectedValue == 'Maturity' && (productFilter.MaturityMin != null && productFilter.MaturityMax == null)
      &&
      (productFilter.MaturityMin != null && productFilter.MaturityMax == null)) {
      isValid = false;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }
    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TechnologyList == null)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.ItemNoList == null || productFilter.ItemNoList.length <= 0)
      && (productFilter.MaturityMin == null)
      && (productFilter.MaturityMax == null)
    ) {
      isValid = false;
    }
    return isValid;
  }

  removeSelectedRow(item) {
    if (item.isProductSelected) {
      this.keepRecords(item);
      this.calculateTotalUnitsSelected();
    }
  }

  public keepRecords(item) {
    if ((item.isProductDeactivated == false
      || (item.deactivationType == null
        || ((item.deactivationType.trim().toLowerCase() == 'full' || item.deactivationType.trim().toLowerCase() == 'partial'))))) {

      const itemNumber = item.itemNumber;
      item.isProductSelected = !item.isProductSelected;

      if (item.isProductSelected) {
        if (!this.selectedProductList.find(i => i.itemNumber === itemNumber)) {
          this.selectedProductList.push({ ...item });
        }
      } else {

        this.selectedProductList = this.selectedProductList.filter(i => i.itemNumber !== itemNumber);
        item.reservationUnits = 0;
        item.desiredDeliveryDate = null;

        // Remove row from grid if it was from a prior search
        if (item.isFromPreviousSearch) {
          this.productList = this.productList.filter((p: any) => p.itemNumber !== itemNumber);
          this.bindDataSource(this.productList);
          return;
        }
      }
    }
  }




  public AddProducts() {
    if (this.selectedProductList.length > 0) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.selectedProductList.length });
      this.toastrService.info('Product Added');
      this.selectedData.productList = this.selectedProductList;
      this.selectedData.productList.forEach(product => {
        product.sellerID = +this.selectedData.sellerAccountNo;
      });
      this.sliderModelService.setData(this.selectedData);
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
      this.router.navigate(['seed-reservation/seed-reservation-reconcile-grower-order']);
      this.sliderModelService.close();
    } else {
      this.toastrService.warning('Please select at least one product.');
    }
  }

  public keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        this.setDefaultFilter();
        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }
        if (this.productFilters.ItemNoList && this.productFilters.ItemNoList.length > 0) {
          let strINO = '';
          this.productFilters.ItemNoList.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Item Number : ' + strINO.substr(0, strINO.length - 2));
        }

        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          this.filterValueList.push('Maturity : (' + this.productFilters.MaturityMin + ') - (' + this.productFilters.MaturityMax + ')');
        }
      }

    }
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
      (this.productFilters.TechnologyList != null && this.productFilters.TechnologyList !== '') ||
      (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.MaturityMin != null) ||
      (this.productFilters.MaturityMax != null) ||
      (this.productFilters.ItemNoList && this.productFilters.ItemNoList.length > 0)) {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();

  }

  enableDisableSearch() {
    if (this.validateProductFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  validateProductSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null && this.productFilters.Brand !== '' && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  validateTechnologySearch() {
    // To Validate Brand
    if (this.productFilters.TechnologyList !== null && this.productFilters.TechnologyList !== '' && this.productFilters.TechnologyList.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }


  public isDefaultFilter(filterValue: string): boolean {
    return filterValue.startsWith('Marketing Brand :')
      || filterValue.startsWith('Product Line :');
  }

  getFilterData() {
    this.keepFilter();
    this.getProducts();
  }

  public clearAllFilter() {
    this.filterValueList = new Array();
    this.selectedProductList = [];
    this.selectedValue = this.searchTypeList[0];
    this.productList = new Array();
    this.isTextBoxEmpty = false;
    this.resetProductFilter();
    this.productDataSource = new MatTableDataSource([]);
    this.unitSelected = 0;
  }

  public clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.enableDisableSearch();
    }
  }

  // To remove clear search filter
  public removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.productFilters.Brand = null;
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        break;
      case 'Technology':
        this.productFilters.TechnologyList = null;
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        break;
      case 'Item Number':
        this.productFilters.ItemNoList = [];
        break;
      default:
        break;
    }
  }

  public loadMasterData() {
    // get Item Number List
    this.subscription.push(this.commonService.getItemNumbers().subscribe((result: any) => {
      this.itemNumberList = result;
    }));

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

  }


  // search in master search area
  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toString().toLocaleLowerCase().indexOf(term) > -1;
  }


  public resetProductFilter() {
    const growerGMK = +(this.selectedData?.gmk ?? this.selectedData?.growerGMK ?? 0);
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'AccountNumber': +this.selectedData.accountNo,
      'GrowerGMK': growerGMK > 0 ? growerGMK : null,
      'IsAvailabilityChecked': true,
      'IsRelatedtoDealerItemsOnly': false,
      'Brand': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': null,
      'TreatmentList': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
      'ItemNoList': []
    };
    this.setDefaultFilter();
  }

  setDefaultFilter() {
    this.productFilters.MarketingBrandList = [this.selectedData.marketingBrand];
    this.productFilters.ProductLineList = [this.selectedData.productLine];
    if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0 && this.productFilters.MarketingBrandList[0] != '') {
      this.filterValueList.push('Marketing Brand : ' + this.productFilters.MarketingBrandList[0]);
    }
    if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0 && this.productFilters.ProductLineList[0] != '') {
      this.filterValueList.push('Product Line : ' + this.productFilters.ProductLineList[0]);
    }
  }


  cancelClick() {
    this.sliderModelService.close();
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
